import { useState } from "react"
import { PreviewAlert } from "event-definitions"

export function usePreviewAlert() {
    const [alerts, setAlerts] = useState({ info: {}, error: {} })
    const hasInfos = !!Object.keys(alerts.info ?? {}).length
    const hasErrors = !!Object.keys(alerts.error ?? {}).length

    PreviewAlert.useEvent(({ error, info }) => {
        setAlerts((prev) => {
            const next = {
                error: { ...prev.error },
                info: { ...prev.info },
            }
            Object.entries(error ?? {}).forEach(([key, val]) => {
                if (val === false) delete next["error"][key]
                else next["error"][key] = val
            })
            Object.entries(info ?? {}).forEach(([key, val]) => {
                if (val === false) delete next["info"][key]
                else next["info"][key] = val
            })
            return next
        })
    })

    return { alerts, hasInfos, hasErrors }
}
